import { Check, Info } from "lucide-react";
import { Reveal, MaskLines } from "@/components/Motion";
import { SectionHead } from "@/components/Common";
import { VISIT_INCLUDES, SERVICE_CLARIFICATION, CONCIERGE_SEPARATE_NOTE, HANDS_ON_NOTE } from "@/data/site";

export const VisitIncludes = () => (
  <section data-testid="visit-includes-section" className="grain relative overflow-hidden bg-[#14263D] py-24 text-white md:py-32">
    <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
      <SectionHead light eyebrow="Every scheduled visit" title={<MaskLines onView lines={["What's Included", "in Every Visit?"]} />} />
      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {VISIT_INCLUDES.map((g, i) => (
          <Reveal key={g.title} delay={i * 0.1} className="rounded-[4px] border border-white/15 bg-white/[0.04] p-8 transition-colors duration-500 hover:bg-white/[0.08]">
            <span className="font-mono text-xs text-[#f0b3b7]">0{i + 1}</span>
            <h3 className="mt-4 font-display text-3xl font-semibold">{g.title}</h3>
            <ul className="mt-6 space-y-3">
              {g.items.map((it) => (
                <li key={it} className="flex gap-3 text-sm leading-relaxed text-white/90 md:text-base">
                  <Check className="mt-1 h-4 w-4 shrink-0 text-[#f0b3b7]" />{it}
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-6 rounded-[4px] border border-[#f0b3b7]/40 p-5 text-sm leading-relaxed text-white md:text-base">
        <p data-testid="hands-on-note">{HANDS_ON_NOTE}</p>
      </Reveal>
      <Reveal className="mt-4 flex items-start gap-3 rounded-[4px] bg-white/10 p-5 text-sm leading-relaxed text-white md:text-base">
        <Info className="mt-0.5 h-5 w-5 shrink-0 text-[#f0b3b7]" />
        <div className="space-y-2">
          <p data-testid="visit-includes-disclaimer">{SERVICE_CLARIFICATION}</p>
          <p data-testid="concierge-separate-note" className="text-white/85">{CONCIERGE_SEPARATE_NOTE}</p>
        </div>
      </Reveal>
    </div>
  </section>
);
